/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether tasks of this event kind require lecturer evaluation
 */
export type EventKindRequiresEvaluation = boolean | null;
